import React from 'react';

interface RegisterStepsCardProps {
  image: string;
  title: string;
  description: string;
}

const RegisterStepsCard: React.FC<RegisterStepsCardProps> = ({
  image,
  title,
  description,
}) => {
  return (
    <div className="relative flex w-full max-w-xs flex-col items-center justify-center gap-8 text-center">
      <img className="max-h-[350px]" src={image} alt="step" loading="lazy" />
      <div className="flex flex-col gap-4">
        <div className="font-semibold text-xl">{title}</div>
        <div className="text-base">{description}</div>
      </div>
    </div>
  );
};

export default RegisterStepsCard;
